import { connectFunctionsEmulator, getFunctions } from "firebase/functions";

var functions = getFunctions();
var isEmulatator = false;

if (isEmulatator) {
  connectFunctionsEmulator(
    functions,
    'localhost',
    '5001'
  );
}

export default functions;
